/**
 * カラーピッカー
 */
export const ColorMaster = [
  "#004986",
  "#007130",
  "#B7AA00",
  "#AC6A00",
  "#A40000",
  "#3f3f3f",
  "#419CC0",
  "#519768",
  "#CAC264",
  "#C49958",
  "#BD6748",
  "#5f5f5f",
  "#00A0E9",
  "#009944",
  "#FFF100",
  "#F39800",
  "#E60012",
  "#7f7f7f",
  "#54C3F1",
  "#69BD83",
  "#FFF67F",
  "#F9C270",
  "#EF845C",
  "#9f9f9f",
];
